import classnames from 'classnames/bind';
import PropTypes from 'prop-types';
import React from 'react';

import IconContainer from 'presentation/components/icons/IconContainer';

import styles from 'presentation/components/styles/SubmitButton.css';

export default function SubmitButton({ onClick, onKeyDown, className }) {
  const submitButtonPropTypes = { onClick: PropTypes.func.isRequired };
  PropTypes.checkPropTypes(submitButtonPropTypes, { onClick, onKeyDown, className }, 'prop', 'SubmitButton');

  let cx = classnames.bind(styles);
  let wrapperClasses = cx(styles.submitButton_wrapper, className);

  return (
    <div tabIndex="0" role="button" className={wrapperClasses} onClick={onClick} onKeyDown={onKeyDown}>
      <div tabIndex="-1" className={styles.submitButton}>
        <IconContainer viewBox="0 0 25 21" title="Send message" titleId="submitButtonTitleId">
          <g fill="none" fillRule="evenodd">
            <path d="M1.577 10.5h21.377" strokeLinecap="square" />
            <path d="M13.4 1l9.6 9.435-9.667 9.5" />
          </g>
        </IconContainer>
      </div>
    </div>
  );
}
